import { render } from "./auditlog.cattle.io.auditpolicy.vue?vue&type=template&id=559eb775&ts=true"
import script from "./auditlog.cattle.io.auditpolicy.vue?vue&type=script&lang=ts"
export * from "./auditlog.cattle.io.auditpolicy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__